import React, { useState } from "react";
import toast from "react-hot-toast";
import { authApiService } from "../../../../api/api";
import { ReactComponent as ContactIcon } from "../../../../assets/icons/supplier/contact.svg";
import { ReactComponent as EmailIcon } from "../../../../assets/icons/supplier/email.svg";
import { ReactComponent as PhoneIcon } from "../../../../assets/icons/supplier/phone.svg";
import { IClientCreateDto } from "../../../../types/clients.type";
import {
  formatPhoneNumber,
  unformatPhoneNumber,
} from "../../../../utils/fotmatPhoneNumber";
import ModalBottomButtons from "../buttons/ModakBottomButtons/ModalBottomButtons";
import EditInput from "../inputs/EditInput/EditInput";
import styles from "./styles.module.scss";

interface Props {
  onClose: () => void;
  onApply: () => void;
}

const AddClientForm: React.FC<Props> = (props) => {
  const [fullName, setFullName] = useState<string>("");
  const [email, setEmail] = useState<string>("");
  const [phone, setPhone] = useState<string>("");
  const [note, setNote] = useState<string>("");

  const onChangePhone = (value: string) => {
    const formated = formatPhoneNumber(value);
    setPhone(formated);
  };

  const onApply = async () => {
    if (!fullName) {
      toast.error('Поле "Постачальник" обовʼязкове');
      return;
    }
    try {
      const body: IClientCreateDto = {
        fullName,
        phone: unformatPhoneNumber(phone),
        email,
        note,
      };

      const response = await authApiService.createClient(body);

      if (response) {
        props.onApply();
        props.onClose();
      }
    } catch (err) {
      console.error(err);
      toast.error("Сталась помилка. Спробуйте пізніше");
    }
  };

  return (
    <div className={styles.container}>
      <form className={styles.form}>
        <EditInput
          value={fullName}
          setValue={(value) => setFullName(value)}
          title="Ім’я та Прізвище"
          isRequired={true}
        >
          <ContactIcon />
        </EditInput>
        <EditInput
          value={email}
          setValue={(value) => setEmail(value)}
          title="Пошта"
          isRequired={false}
        >
          <EmailIcon />
        </EditInput>

        <EditInput
          value={phone}
          setValue={onChangePhone}
          title="Номер телефону"
          isRequired={false}
        >
          <PhoneIcon />
        </EditInput>
        <EditInput
          value={note}
          setValue={(value) => setNote(value)}
          title="Примітка"
          isRequired={false}
          isBig={true}
        />
      </form>
      <ModalBottomButtons
        onPressBack={props.onClose}
        onPressApply={onApply}
        backTitle="Назад"
        applyTitle="Додати клієнта"
      />
    </div>
  );
};

export default AddClientForm;
